import { NICHES, CATEGORY_ACCENTS } from '@/data/keywords'

const DIFFICULTY_TONE: Record<string, string> = {
  'Very Low': 'text-emerald-600',
  Low: 'text-emerald-600',
  'Low-Med': 'text-amber-600',
  Med: 'text-amber-600',
  High: 'text-rose-600',
}

export default function LaunchCenter() {
  return (
    <section className="mx-auto max-w-7xl px-6 pt-12">
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-900 px-8 py-10 text-white">
          <div className="flex flex-wrap items-center gap-2 text-xs font-medium uppercase tracking-widest text-slate-400">
            <span className="inline-flex h-2 w-2 rounded-full bg-emerald-400" />
            Domain Launch Command Center
          </div>
          <h1 className="mt-4 max-w-3xl text-4xl font-bold leading-tight tracking-tight sm:text-5xl">
            <span className="font-mono text-emerald-400">junctioncalculator.com</span>
            <span className="block text-slate-100">The Omni-Calculator for junctions, interfaces &amp; connections.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300">
            A multi-niche programmatic calculator portal targeting six low-competition engineering disciplines.
            By matching <span className="font-semibold text-white">tool-seeking intent</span> instead of long-form articles,
            the strategy drives low bounce rates, high bookmark rates, and natural backlinks from academic and
            professional references.
          </p>
          <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-4">
            <Metric value="6" label="Target niches" />
            <Metric value="50" label="Vetted keywords" />
            <Metric value="4" label="Live calculators" />
            <Metric value="< 20" label="Avg. difficulty" />
          </div>
        </div>

        <div className="grid gap-px bg-slate-200 sm:grid-cols-2 lg:grid-cols-3">
          {NICHES.map((n) => {
            const accent = CATEGORY_ACCENTS[n.category]
            return (
              <div key={n.category} className="group bg-white p-6 transition hover:bg-slate-50">
                <div className="flex items-center justify-between">
                  <span className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-semibold ${accent.badge}`}>
                    <span className={`h-1.5 w-1.5 rounded-full ${accent.dot}`} />
                    {n.category}
                  </span>
                  <span className={`font-mono text-xs font-bold ${DIFFICULTY_TONE[n.difficulty] ?? 'text-slate-500'}`}>
                    {n.difficulty}
                  </span>
                </div>
                <h3 className="mt-3 text-base font-semibold text-slate-900">{n.label}</h3>
                <p className="mt-1 text-sm text-slate-500">{n.description}</p>
                <p className="mt-3 border-t border-slate-100 pt-3 text-xs leading-relaxed text-slate-500">
                  {n.rationale}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

function Metric({ value, label }: { value: string; label: string }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 px-4 py-3">
      <div className="font-mono text-2xl font-bold text-white">{value}</div>
      <div className="text-xs text-slate-400">{label}</div>
    </div>
  )
}
